import PersonInCircle from "./SVG/person-in-circle.svg?react";

const PersonInCircleIcon = () => {
  return <PersonInCircle />;
};

export default PersonInCircleIcon;
